import type { OrganisationLabel } from 'shared/api';
import {
  DISALLOWED_LABEL_CHARACTER_PATTERN,
  ITERATION_LABEL_MESSAGES,
  ORGANISATION_LABEL_NAME_PATTERN,
} from './constants';

export const isDuplicateLabelName = (
  name: string,
  entries: OrganisationLabel[],
  excludeId?: string | null,
): boolean => {
  const normalizedName = name.trim().toLowerCase();

  return entries.some(
    (entry) =>
      entry.id !== excludeId &&
      entry.name.trim().toLowerCase() === normalizedName,
  );
};

export const isValidOrganisationLabelName = (value: string): boolean =>
  ORGANISATION_LABEL_NAME_PATTERN.test(value);

/**
 * Removes characters the backend rejects (emojis, symbols outside the
 * allowlist) so pasted or dropped text can't reach the input value.
 */
export const stripDisallowedLabelCharacters = (value: string): string =>
  value.replace(DISALLOWED_LABEL_CHARACTER_PATTERN, '');

export const getLabelValidationError = (
  value: string,
  entries: OrganisationLabel[],
  excludeId?: string | null,
): string | null => {
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    return ITERATION_LABEL_MESSAGES.Empty;
  }

  if (isDuplicateLabelName(trimmedValue, entries, excludeId)) {
    return ITERATION_LABEL_MESSAGES.Duplicate;
  }

  return null;
};
